import { z } from "zod";

const MetaLinkSchema = z.object({
  url: z.string().nullable(),
  label: z.string(),
  active: z.boolean(),
});

export const createApiResponseSchema = <T extends z.ZodType>(dataSchema: T) =>
  z.object({
    data: z.array(dataSchema),
    links: z.object({
      first: z.string(),
      last: z.string(),
      prev: z.string().nullable(),
      next: z.string().nullable(),
    }),
    meta: z.object({
      current_page: z.number(),
      from: z.number(),
      last_page: z.number(),
      links: z.array(MetaLinkSchema),
      path: z.string(),
      per_page: z.number(),
      to: z.number(),
      total: z.number(),
    }),
  });

export const createApiResponseIndividualSchema = <T extends z.ZodType>(
  dataSchema: T,
) =>
  z.object({
    data: dataSchema,
    links: z.object({
      first: z.string(),
      last: z.string(),
      prev: z.string().nullable(),
      next: z.string().nullable(),
    }),
    meta: z.object({
      current_page: z.number(),
      from: z.number(),
      last_page: z.number(),
      links: z.array(MetaLinkSchema),
      path: z.string(),
      per_page: z.number(),
      to: z.number(),
      total: z.number(),
    }),
  });
